import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import type { SessionTypeSlice } from '@/lib/dashboard/useDashboardAnalytics';

export function SessionTypeBreakdown({ data }: { data: SessionTypeSlice[] }) {
  const total = data.reduce((sum, d) => sum + d.count, 0);

  return (
    <div className="glass-card flex h-[340px] flex-col p-5">
      <p className="mb-4 text-xs font-medium uppercase tracking-wider text-muted-foreground">
        Session breakdown
      </p>

      <div className="relative min-h-0 flex-1">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="count"
              nameKey="label"
              cx="50%"
              cy="50%"
              innerRadius={55}
              outerRadius={80}
              strokeWidth={0}
            >
              {data.map((slice) => (
                <Cell key={slice.type} fill={slice.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        {/* Center label */}
        <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-display text-2xl font-semibold text-white">{total}</span>
          <span className="text-[11px] text-muted-foreground">total</span>
        </div>
      </div>

      {/* Legend */}
      <div className="mt-2 flex items-center justify-center gap-5">
        {data.map((slice) => (
          <div key={slice.type} className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: slice.color }} />
            <span className="text-xs text-muted-foreground">
              {slice.label}
              <span className="ml-1 font-semibold text-white">{slice.count}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
